var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.04635 1.04635C1.24161 0.851087 1.55819 0.851087 1.75346 1.04635L5.9961 5.28899L10.2387 1.04635C10.434 0.851087 10.7506 0.851087 10.9458 1.04635C11.1411 1.24161 11.1411 1.55819 10.9458 1.75346L6.7032 5.9961L10.9458 10.2387C11.1411 10.434 11.1411 10.7506 10.9458 10.9458C10.7506 11.1411 10.434 11.1411 10.2387 10.9458L5.9961 6.7032L1.75346 10.9458C1.55819 11.1411 1.24161 11.1411 1.04635 10.9458C0.851087 10.7506 0.851087 10.434 1.04635 10.2387L5.28899 5.9961L1.04635 1.75346C0.851087 1.55819 0.851087 1.24161 1.04635 1.04635Z",
    fill: "#662B0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.7e078828ba8aa7f6760441d34ace19ba.svg";
export { ForwardRef as ReactComponent };